module.exports = __webpack_public_path__ + "static/media/star-icon.2f3563bb.svg";